import React from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import { Dumbbell, Printer, Mail } from 'lucide-react'; 

const NotificationViewModal = ({ isOpen, onClose, notificationData }) => {

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={notificationData?.title}>
            <div className="space-y-4"> 
                    <p className="  text-gray-700 whitespace-pre-line">
                        {notificationData?.message}
                    </p>
                    <p className="mt-3 text-sm text-gray-500">
                        To: {notificationData?.target_group}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                        {notificationData?.created_at}
                    </p>
 
                <div className="pt-4 flex justify-end gap-3"> 
                    <button onClick={onClose} className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700">
                         Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NotificationViewModal;
